module.exports = __webpack_public_path__ + "img/login.3fc1bc0d.svg";